// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bqum","question":"styles_question__TDo_9","description":"styles_description__2ZrlZ"};